export const configuracionColumnasSeguros = [
    {
        name: "seguro",
        field: "seguro",
        label: "Seguro",
        align: "left",
    },
    {
        name: "tipo_seguro",
        field: "tipo_seguro",
        label: "Tipo de seguro",
        align: "left",
    },
    {
        name: "mensaje",
        field: "mensaje",
        label: "Mensaje",
        align: "left",
    },
    {
        name: "cobertura_atencion",
        field: "cobertura_atencion",
        label: "Registro de cobertura de de atención de salud",
        align: "left",
    },
];
